import { render, staticRenderFns } from "./SeoComponent.vue?vue&type=template&id=89ba4906"
import script from "./SeoComponent.vue?vue&type=script&lang=js"
export * from "./SeoComponent.vue?vue&type=script&lang=js"
import style0 from "./SeoComponent.vue?vue&type=style&index=0&id=89ba4906&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports